import moment from "moment";
import { useEffect, useState } from "react";

export default function useDataSummary<T> (data: Array<T>, dateField: keyof T) {
    const [earliestDate, setEarliestDate] = useState('');
    const [latestDate, setLatestDate] = useState('');

    useEffect(() => {
        if (data.length > 0) {
            data.sort((a, b) => +moment(a[dateField]) - +moment(b[dateField]));
            setEarliestDate(moment.utc(data[0][dateField]).format('MM/DD/YYYY HH:mm'));
            setLatestDate(moment.utc(data[data.length - 1][dateField]).format('MM/DD/YYYY HH:mm'));
        }
    }, [data]);

    const summary = `Showing ${data.length} records from ${earliestDate} to ${latestDate}`;

    return {
        earliestDate,
        latestDate,
        summary
    }
}